// Carousel
jQuery(document).ready(function($) {

  // Horizontal scroll =======================

  if($(window).width() > 1000){
    horizontalScroll();
  }

  $(window).on('resize', function(){
    horizontalScroll();
  });

  // Calculate max value of progress bar
  function horizontalScroll(){
    const sliderContainer = document.querySelector('.impact-horizontal-scroll');
    const sliderProgressWrapper = document.querySelector('.impact-report__progress');
    const sliderProgress = document.querySelector('.impact-report__progress-bar');

    function runScroll(e){
      let deltaY = e.deltaY;
      sliderContainer.scrollLeft += deltaY;
      sliderProgress.stepUp(Math.round(deltaY));
    }

    function clickProgress(e){
      sliderContainer.scrollLeft = e.target.value;
    }

    if($(window).width() > 1000){

      // If slider does not need to scroll, hide scrollbar
      const sliderWidth = sliderContainer.scrollWidth;
      if(sliderWidth < $(window).width() || sliderWidth == $(window).width()){
        // Hide scrollbar
        sliderProgressWrapper.style.display = "none";

        // Stop any scroll stuff
        sliderContainer.scrollLeft = 0;
        sliderContainer.removeEventListener("wheel", runScroll);
        sliderProgress.removeEventListener("input", clickProgress);

      }else{
        sliderProgressWrapper.style.display = "block";

        // Set progress bar max to slider width
        sliderProgress.setAttribute("max",sliderWidth);

        // Run horizontal scroll & adjust progress bar on mousescroll
        sliderContainer.addEventListener("wheel", runScroll);

        // Adjust horizontal scroll position on progress bar change
        if ("oninput" in sliderProgress) {
            sliderProgress.addEventListener("input", clickProgress);
        }
      }
    }else{
      // Stop scroll stuff in mobile
      sliderContainer.scrollLeft = 0;
      sliderContainer.removeEventListener("wheel", runScroll);
      sliderProgress.removeEventListener("input", clickProgress);
    }

  }


  // Impact Drawer =======================
  const drawer = document.querySelector('.impact-drawer');
  if(drawer){

    // Toggle drawer
    const drawerTriggers = drawer.querySelectorAll('.impact-drawer-toggle');
    for (let i = 0; i < drawerTriggers.length; i++) {
      drawerTriggers[i].addEventListener('click', function () {
        const body = document.body.classList.toggle('impact-drawer-active');
        drawer.classList.toggle('active');
        drawerTriggers[i].classList.toggle('active');
      });
    }

    // Mobile toggle drawer
    const mobileTrigger = document.querySelector('.mega-menu-toggle');
    mobileTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      const body = document.body.classList.toggle('impact-drawer-active');
      drawer.classList.toggle('active');
    });

    // Toggle children
    const hasChildren = drawer.querySelectorAll('.has-children');
    const toggleChildren = drawer.querySelectorAll('.toggle-children');
    const back = drawer.querySelectorAll('.impact-drawer__back');
    for (let i = 0; i < hasChildren.length; i++) {
      toggleChildren[i].addEventListener('click', function () {
        hasChildren[i].classList.toggle('active');
      });
      back[i].addEventListener('click', function () {
        hasChildren[i].classList.toggle('active');
      });
    }


  }

  // Impact Financials Anchor Links =======================
  const financials = document.querySelector('.impact-financials');
  if(financials){

    // Generate anchor links
    const nav = document.querySelector('.impact-financials__cover-links');
    const anchors = document.querySelectorAll('[data-anchor]');
    for (let i = 0; i < anchors.length; i++) {
      const anchor = anchors[i].getAttribute("data-anchor");
      if(anchor !== ""){
        const index = anchors[i].closest(".slick-slide").getAttribute("data-slick-index");
        nav.innerHTML += '<a href="#" data-slide="'+index+'">'+anchor+'</a>';
      }
    }

    // Click anchor link to slide
    const nav_links = nav.querySelectorAll('a');
    for (let i = 0; i < nav_links.length; i++) {
      nav_links[i].addEventListener("click", function(e){
        e.preventDefault();
        const slide_number = nav_links[i].getAttribute("data-slide");
        $('.slick-carousel').slick('slickGoTo', slide_number);
      });
    }
  }

  // Impact Funders Arrow =======================
  /*
  const funders = document.querySelector('.impact-funders');
  if(funders){
    const lists = document.querySelectorAll('.impact-funders__list');
    const buttons = document.querySelectorAll('.impact-funders__arrow');
    for (let i = 0; i < lists.length; i++) {
      // Check if the list is scrollable and should have an arrow
      if(lists[i].scrollHeight > lists[i].offsetHeight){
        // Is scrollable
        buttons[i].addEventListener("click", function(){
          if(lists[i].offsetHeight + Math.round(lists[i].scrollTop) >= lists[i].scrollHeight){
            lists[i].scrollTop = 0;
          }else{
            lists[i].scrollTop += 100;
          }
        });
      }else{
        // Is not scrollable
        lists[i].closest('.impact-funders__box').classList.add('impact-funders__box--short');
      }
    }
  }*/

  // Impact Global Arrow =======================
  /*
  const global = document.querySelector('.impact-global');
  if(global){
    const lists = document.querySelectorAll('.impact-global__list');
    const buttons = document.querySelectorAll('.impact-global__arrow');
    for (let i = 0; i < lists.length; i++) {
      // Check if the list is scrollable and should have an arrow
      if(lists[i].scrollHeight > lists[i].offsetHeight){
        // Is scrollable
        buttons[i].addEventListener("click", function(){
          if(lists[i].offsetHeight + Math.round(lists[i].scrollTop) >= lists[i].scrollHeight){
            lists[i].scrollTop = 0;
          }else{
            lists[i].scrollTop += 100;
          }
        });
      }else{
        // Is not scrollable
        lists[i].closest('.impact-global__box').classList.add('impact-global__box--short');
      }
    }
  }*/


});


